<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Hardware Setup</h4>
					<button class="float-right btn btn-primary shadow"
					        v-on:click="formHardwareSetupActive=!formHardwareSetupActive">{{
							dicts.add_form[dicts.lang]
						}}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formHardwareSetupActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.tittle_form[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">Pelanggan</label>
								<smart-search init url="/api/master/seeker/applications" key-tag="application_name"
								              v-on:update="(data)=>smartSearchAddApplication(data)"
								              :search-value="newsetupapplabel"
								              @update-direct="(label)=>newsetupapplabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">ODP</label>
								<smart-search init url="/api/master/seeker/hardware" key-tag="hardware_name" :label-tag="['item','hardware_name']"
								              v-on:update="(data)=>smartSearchAddSplitterNumber(data)"
								              :search-value="newsetupodplabel"
								              @update-direct="(label)=>newsetupodplabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">SN</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newHardwareSetup.id_transmitter"/>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">Mac Address</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newHardwareSetup.mac_address"/>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">{{ dicts.activate_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-activate-date" v-model="newHardwareSetup.date_active" class="mb-2">
									{{ newHardwareSetup.date_active }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-due-date" v-model="newHardwareSetup.date_due" class="mb-2">
									{{ newHardwareSetup.date_due }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">NOC</label>
								<smart-search init url="/api/master/seeker/nocs" key-tag="noc"
								              v-on:update="(data)=>smartSearchAddNoc(data)"
								              :search-value="newsetupnoclabel"
								              @update-direct="(label)=>newsetupnoclabel=label"></smart-search>
							</div>

							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.no_sn[dicts.lang] }}</label>
								<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
								              :addon="{item:'Antena'}"
								              key-tag="serial_number" v-on:clear="(res)=>{clearHQCData()}"
								              v-on:update="(data)=>smartSearchAddSerialNumber(data)"
								              :search-value="newsetupsnlabel"
								              @update-direct="(label)=>newsetupsnlabel=label"></smart-search>
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.no_jb[dicts.lang] }}</label>
								<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
								              :addon="{item:'jb'}"
								              key-tag="serial_number" v-on:update="(data)=>smartSearchAddNoJb(data)"
								              :search-value="newsetupjblabel"
								              @update-direct="(label)=>newsetupjblabel=label"></smart-search>
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.vessel[dicts.lang] }}</label>
								<b-button class="btn btn-light mr-2 form-control w-100 rounded d-flex align-items-start"
								          v-b-modal.modal-create-vessel v-model="newHardwareSetup.vessel_id">
									{{ selectedVesselName }}
								</b-button>
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Client (Pemilik)</label>
								<input type="text" class="form-control w-100 rounded" v-model="newHardwareSetup.client" />
								<b-button class="btn btn-light mr-2 form-control w-100 rounded" v-b-modal.modal-lg-prevent-closing>
								<div v-if="submittedNames.length === 0" class="d-flex align-items-end">--</div>
								<div v-for="name in submittedNames" class="d-flex align-items-start">{{ name }}</div>
								</b-button>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Legal Name</label>
								<input type="text" class="form-control w-100 rounded" v-model="newHardwareSetup.name_legal" />
								<b-button class="btn btn-light mr-2 form-control w-100 rounded" v-b-modal.modal-lg-prevent-closing>
								<div v-if="submittedNames.length === 0" class="d-flex align-items-end">--</div>
								<div v-for="name in submittedNames" class="d-flex align-items-start">{{ name }}</div>
								</b-button>
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Status</label>
								<smart-select name="status" :options="statusTypeOptions"
								              v-on:update="updateNewHsStatus"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Forward</label>
								<smart-select name="forward" :options="forwardTypeOptions"
								              v-on:update="updateNewHsForward"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.test_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-test-date" v-model="newHardwareSetup.date_test" class="mb-2">
									{{ newHardwareSetup.date_test }}
								</b-form-datepicker>
							</div> -->
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.skat_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-skat" v-model="newHardwareSetup.date_skat" class="mb-2">
									{{ newHardwareSetup.date_skat }}
								</b-form-datepicker>
							</div> -->
							<div class="col-12 col-md-6 mt-2">
								<label class="d-block">Status</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newHardwareSetup.notes"/>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newHardwareSetupSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Hardware Setup Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewHardwareSetup">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Hardware Setup Baru.</p>
										</div>
										<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewHardwareSetup">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewHardwareSetup">
									{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<!-- MODAL ADD VESSEL -->
				<b-modal id="modal-create-vessel" title="Add Vessel" hide-footer @show="resetModal" @hidden="resetModal"
				         @ok="handleOk" size="lg" scrollable>

					<ul class="nav nav-tabs">
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==0?'active':'']" href="#"
							        v-on:click="selectedTab=0;newHardwareSetup.vesselExisting='existing'">
								{{ dicts.new_vessel[dicts.lang] }}
							</button>
						</li>
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==1?'active':'']" href="#"
							        v-on:click="selectedTab=1;newHardwareSetup.vesselExisting='new'">
								{{ dicts.list_vessel[dicts.lang] }}
							</button>
						</li>
					</ul>
					<div class="tab-content" id="myTabContent">
						<div v-if="selectedTab==0">
							<create-vessel @createvessel="createVesselResult" :formstate="true" noshadow/>
						</div>
						<div v-if="selectedTab==1">
							<div class="row w-100" style="height:500px">
								<div class="col-12 my-2 py-0">
									<div class="row p-3 mx-2 bg-white">
										<div class="col-12 mt-2">
											<label class="">{{ dicts.list_vessel[dicts.lang] }}</label>
											<smart-search init url="/api/master/seeker/vessel" key-tag="name"
											              v-on:update="(data)=>smartSearchUpdatedVessel(data,idx-1)"
											              :search-value="listvessellabel"
											              @update-direct="(label)=>listvessellabel=label"></smart-search>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-modal>

				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="hardwaresetups"
					           :structure="hardwaresetupTableStructure" :init="loadData" :next-url="nextUrl"
					           :prev-url="prevUrl"
					           @change-page="(isNext)=>{changePage(isNext)}"
					           use-filter use-seeker seeker-url="/api/inventaris/seeker/hardware-setup"
					           @refetch="(row)=>{rowLimit=row;getHardwareSetups()}"
					           @searching="(val)=>!val.status?getHardwareSetups():hardwaresetups=val.data"
					           @change-url="(url)=>getHardwareSetups(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.no_sn[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{
												obj.serial_number ? obj.serial_number.serial_number : "-"
											}}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">SN:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.id_transmitter ? obj.id_transmitter : "-"
											}}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.no_jb[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.jb ? obj.jb.serial_number : "-" }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.vessel[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.vessel ? obj.vessel.name : "-" }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.customer_name[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{
												obj.vessel
													? obj.vessel.client
														? obj.vessel.client.first_name
													: "-"
													: "-"
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.packet[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ translatePacket(obj.packet) }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.due_date[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.date_due | timeformat
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.date_active[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.date_active | timeformat
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-detail-hardware class="btn btn-primary mr-2 mb-1"
											          v-on:click="selectedDetail=index" title="View">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-detail-histories-hardware
											          class="btn btn-success mr-2 mb-1"
											          v-on:click="selectedHistories=index" title="History">
												<b-icon icon="clock-history"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-status-hardware
											          class="btn btn-warning mr-2 mb-1"
											          v-on:click="selectedIdforEditStatus=index" title="Edit status">
												<b-icon icon="arrow-counterclockwise"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-hardware class="btn btn-info mr-2 mb-1"
											          v-on:click="selectedIdforEdit=index" title="Edit">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<!-- <b-button v-b-modal.modal-delete-po v-on:click="selectedToDelete=idx" class="btn btn-danger"><b-icon icon="trash-fill"></b-icon></b-button> -->
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger mr-2 mb-1" title="Delete">
												<b-icon icon="trash"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<!-- isi table -->
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.application ? obj.application.application_name : "-" }}</td>
							<td v-if="!isMobile">{{ obj.application ? obj.application.id_client : "-" }}</td>
							<td v-if="!isMobile">{{ obj.master_hardware ? obj.master_hardware.item : "-" }}</td>
							<td v-if="!isMobile">{{ obj.id_transmitter ? obj.id_transmitter : "-" }}</td>
							<td v-if="!isMobile">{{ obj.mac_address ? obj.mac_address : "-" }}</td>
							<td v-if="!isMobile">{{ obj.date_active | timeformat }}</td>
							<td v-if="!isMobile">{{ obj.date_due | timeformat }}</td>
							<td v-if="!isMobile">{{ obj.noc ? obj.noc.noc : "-" }}</td>
							<td v-if="!isMobile">{{ obj.notes ? obj.notes : "-" }}</td>
							<!-- <td v-if="!isMobile">{{ obj.master_hardware ? obj.master_hardware.hardware_name : "-" }}</td> -->
							<!-- <td v-if="!isMobile">{{ obj.serial_number ? obj.serial_number.serial_number : "-" }}</td>
							<td v-if="!isMobile">{{ obj.jb ? obj.jb.serial_number : "-" }}</td>
							<td v-if="!isMobile">{{ obj.vessel ? obj.vessel.name : "-" }}</td>
							<td v-if="!isMobile">{{ obj.vessel ? obj.vessel.client.first_name : "-" }}</td>
							<td v-if="!isMobile">{{ translatePacket(obj.packet) }}</td>
							<td v-if="!isMobile">{{ obj.date_test | timeformat }}</td> -->
							<!-- <td v-if="!isMobile">{{ obj.status ? obj.status : "-" }}</td> -->
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-detail-hardware class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index">
									<b-icon icon="eye" title="View"></b-icon>
								</b-button>
								<!-- <b-button v-b-modal.modal-detail-histories-hardware class="btn btn-success mr-2 mb-1"
								          v-on:click="selectedHistories=index" title="History">
									<b-icon icon="clock-history"></b-icon>
								</b-button> -->
								<!-- <b-button v-b-modal.modal-edit-status-hardware class="btn btn-warning mr-2 mb-1"
								          v-on:click="selectedIdforEditStatus=index" title="Edit status">
									<b-icon icon="arrow-counterclockwise"></b-icon>
								</b-button> -->
								<b-button v-b-modal.modal-edit-hardware class="btn btn-info mr-2 mb-1"
								          v-on:click="selectedIdforEdit=index">
									<b-icon icon="pencil-square" title="Edit"></b-icon>
								</b-button>
								<!-- <b-button v-b-modal.modal-delete-po v-on:click="selectedToDelete=idx" class="btn btn-danger"><b-icon icon="trash-fill"></b-icon></b-button> -->
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mr-2 mb-1">
									<b-icon icon="trash" title="Delete"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>
				<!-- <div class="col-12  my-2 py-0">
				  <datatable :datas="hardwaresetups" :structure="hardwaresetupTableStructure" :init="loadData">
					  <template #customcell={obj}>
						  <td>{{obj.serial_number_id?obj.serial_number_id.serial_number:'-'}}</td>
						  <b-button v-b-modal.modal-edit-po class="btn btn-info mr-2" v-on:click="selectedIdforEdit=idx"><b-icon icon="pencil-square"></b-icon></b-button>
						  <b-button v-b-modal.modal-delete-po v-on:click="selectedToDelete=idx" class="btn btn-danger"><b-icon icon="trash-fill"></b-icon></b-button>
					  </template>
				  </datatable>
				</div> -->


				<b-modal id="modal-edit-hardware" title="Edit data" scrollable no-close-on-backdrop size="lg">
					<div class="row" v-if="hardwaresetups[selectedIdforEdit]!=undefined">
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Nomor SN</label>
							<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata" :usedefault="hardwaresetups[selectedIdforEdit].serial_number!=null" :default-value="hardwaresetups[selectedIdforEdit].serial_number!=null?hardwaresetups[selectedIdforEdit].serial_number.serial_number:''" :addon="{item:'antena'}" key-tag="serial_number" v-on:clear="(res)=>{clearHQCData()}" v-on:update="(data)=>smartSearchAddSerialNumber(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">ID Transmitter</label>
							<input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].id_transmitter" />
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">No JB</label>
							<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata" :usedefault="hardwaresetups[selectedIdforEdit].jb!=null" :default-value="hardwaresetups[selectedIdforEdit].jb!=null?hardwaresetups[selectedIdforEdit].jb.serial_number:''" :addon="{item:'jb'}" key-tag="serial_number" v-on:update="(data)=>smartSearchAddNoJb(data)"></smart-search>
						</div> -->
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.vessel[dicts.lang] }}</label>
							<smart-search init url="/api/master/seeker/vessel" key-tag="name"
							              :usedefault="hardwaresetups[selectedIdforEdit].vessel!=null"
							              :default-value="hardwaresetups[selectedIdforEdit].vessel!=null?hardwaresetups[selectedIdforEdit].vessel.name:''"
							              v-on:update="(data)=>updateKapal(data)"></smart-search>
						</div> -->
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Status</label>
							<smart-select name="status" :options="statusTypeOptions" v-on:update="(value)=>{hardwaresetups[selectedIdforEdit].status=value}"></smart-select>
						</div> -->
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.packet[dicts.lang] }}</label>
							<smart-select name="packet" usedefault
							              :default-value="translatePacket(hardwaresetups[selectedIdforEdit].packet)"
							              :options="packetTypeOptions"
							              v-on:update="(value)=>{hardwaresetups[selectedIdforEdit].packet=value}"></smart-select>
						</div> -->
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">Nama</label>
							<!-- <smart-select name="application_id" :options="aplicationTypeOptions" v-on:update="(value)=>{hardwaresetups[selectedIdforEdit].aplication=value}" :default-value="hardwaresetups[selectedIdforEdit].application_id" usedefault></smart-select> -->
							<smart-search init url="/api/master/seeker/applications" usedefault
							              :default-value="hardwaresetups[selectedIdforEdit].application.application_name"
							              key-tag="application_name"
							              v-on:update="(data)=>smartSearchUpdateApplication(data)"></smart-search>
							<!-- <input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].application_id" /> -->
						</div>
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">ODP</label>

							<smart-search init url="/api/master/seeker/hardware" usedefault
							key-tag="hardware_name" 
							:label-tag="['item','hardware_name']" 
							:default-value="hardwaresetups[selectedIdforEdit].master_hardware.item" 
							v-on:update="(data)=>smartSearchUpdateMasterHardware(data)"></smart-search>

							<!-- <smart-search init url="/api/master/seeker/hardware" 
							key-tag="hardware_name" 
							:label-tag="['item','hardware_name']"
							v-on:update="(data)=>smartSearchAddSplitterNumber(data)"
							:search-value="newsetupodplabel"
							@update-direct="(label)=>newsetupodplabel=label"></smart-search> -->

						</div>
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">SN</label>
							<input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].id_transmitter" />
						</div>
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">MAC Address</label>
							<input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].mac_address" />
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Forward</label>
							<smart-select name="forward" usedefault
							              :default-value="translateForward(hardwaresetups[selectedIdforEdit].forward)"
							              :options="forwardTypeOptions"
							              v-on:update="(value)=>{hardwaresetups[selectedIdforEdit].forward=value}"></smart-select>
						</div> -->
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.test_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-test-date"
							                   v-model="hardwaresetups[selectedIdforEdit].date_test"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_test }}
							</b-form-datepicker>
						</div> -->
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">{{ dicts.activate_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-activate-date"
							                   v-model="hardwaresetups[selectedIdforEdit].date_active"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_active }}
							</b-form-datepicker>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.skat_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-skat"
							                   v-model="hardwaresetups[selectedIdforEdit].date_skat"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_skat }}
							</b-form-datepicker>
						</div> -->
						<div class="col-12 col-md-6 mt-2">
							<label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-due-date"
							                   v-model="hardwaresetups[selectedIdforEdit].date_due"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_due }}
							</b-form-datepicker>
						</div>
						<div class="col-12 mt-2">
							<label class="d-block">Status</label>
							<textarea type="text" class="form-control w-100 rounded"
							          v-model="hardwaresetups[selectedIdforEdit].notes"/>
						</div>
						<!--<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.jb_number[dicts.lang] }}</label> -->
							<!-- <input type="text" class="form-control w-100 rounded"
							       v-model="hardwaresetups[selectedIdforEdit].jb != null ? hardwaresetups[selectedIdforEdit].jb.serial_number : newHardwareSetup.jbNumber"/> -->
							<!-- <smart-search init url="/api/inventaris/seeker/hardware-qc-metadata"
							              :usedefault="hardwaresetups[selectedIdforEdit].jb!=null"
							              :default-value="hardwaresetups[selectedIdforEdit].jb!=null?hardwaresetups[selectedIdforEdit].jb.serial_number:''"
							              :addon="{item:'jb'}" key-tag="serial_number"
							              v-on:update="(data)=>smartSearchUpdateNoJb(data)"></smart-search>
						</div>-->

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Hardware Setup.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Hardware Setup.</p>
										</div>
										<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" v-on:click="updateHardwareSetup">
									{{ dicts.submit[dicts.lang] }}
								</button>
								<button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-hardware')">
									{{ dicts.close[dicts.lang] }}
								</button>
							</div>
						</div>
					</template>
				</b-modal>

				<b-modal id="modal-edit-status-hardware" title="Ubah Status" scrollable no-close-on-backdrop size="lg">
					<div class="row" v-if="hardwaresetups[selectedIdforEditStatus]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Status</label>
							<smart-select name="status" :options="statusTypeOptions" usedefault
							              :default-value="hardwaresetups[selectedIdforEditStatus].status"
							              v-on:update="(value)=>{hardwaresetups[selectedIdforEditStatus].status=value}"></smart-select>
						</div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSavedStatus">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Hardware Setup.
								</div>
							</div>
						</div>

						<div class="col-12 w-100 my-3"
						     v-if="hardwaresetups[selectedIdforEditStatus].status=='replacement'">
							<!-- field new client -->
							<div class="w-100">
								<div class="row mt-3">
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">{{ dicts.no_sn[dicts.lang] }}</label>
										<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
										              :usedefault="hardwaresetups[selectedIdforEditStatus].serial_number!=null"
										              :default-value="hardwaresetups[selectedIdforEditStatus].serial_number!=null?hardwaresetups[selectedIdforEditStatus].serial_number.serial_number:''"
										              :addon="{item:'antena'}" key-tag="serial_number"
										              v-on:clear="(res)=>{clearHQCDataStatus()}"
										              v-on:update="(data)=>smartSearchEditSerialNumber(data)"></smart-search>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">ID Transmitter</label>
										<input type="text" class="form-control w-100 rounded"
										       v-model="hardwaresetups[selectedIdforEditStatus].id_transmitter"/>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">{{ dicts.no_jb[dicts.lang] }}</label>
										<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
										              :usedefault="hardwaresetups[selectedIdforEditStatus].jb!=null"
										              :default-value="hardwaresetups[selectedIdforEditStatus].jb!=null?hardwaresetups[selectedIdforEditStatus].jb.serial_number:''"
										              :addon="{item:'jb'}" key-tag="serial_number"
										              v-on:update="(data)=>smartSearchEditNoJb(data)"></smart-search>
									</div>
									<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">Tanggal</label>
										<b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date" v-model="hardwaresetups[selectedIdforEdit].date_at" class="mb-2">{{hardwaresetups[selectedIdforEdit].date_at}}</b-form-datepicker>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">Keterangan</label>
										<textarea type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEditStatus].notes" />
									</div> -->
								</div>
							</div>
						</div>

						<div class="col-12 w-100 my-3">
							<div class="w-100">
								<div class="row mt-3">
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">{{ dicts.date[dicts.lang] }}</label>
										<b-form-datepicker today-button reset-button close-button
											:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
											id="datepicker-due-date"
											v-model="hardwaresetups[selectedIdforEditStatus].date_at" class="mb-2">
											{{ hardwaresetups[selectedIdforEditStatus].date_at }}
										</b-form-datepicker>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
										<textarea type="text" class="form-control w-100 rounded"
										          v-model="hardwaresetups[selectedIdforEditStatus].notes"/>
									</div>
								</div>
							</div>
						</div>

					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdateStatus">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Hardware Setup.</p>
										</div>
										<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updatingStatus">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button"
								        v-on:click="updateStatusHardwareSetup">
									{{ dicts.submit[dicts.lang] }}
								</button>
								<b-button class="btn btn-secondary mr-2"
								          @click="$bvModal.hide('modal-edit-status-hardware')">
									{{ dicts.close[dicts.lang] }}
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-hardware" title="Detail data" scrollable
				         no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&hardwaresetups.length>0">
						<b-row class="pt-1" v-if="hardwaresetups[selectedDetail]!=undefined">
							<b-col cols="12">
								<table rules="rows" class="table w-100">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">Detail
											Hardware Setup
										</th>
									</tr>
									<tr>
										<th scope="row">Nama</th>
										<td>{{ hardwaresetups[selectedDetail].application.application_name }}</td>
									</tr>
									<tr>
										<th scope="row">CID</th>
										<td>{{ hardwaresetups[selectedDetail].application.id_client }}</td>
									</tr>
									<tr>
										<th scope="row">ODP</th>
										<td>
											{{
												hardwaresetups[selectedDetail].master_hardware != null ? hardwaresetups[selectedDetail].master_hardware.item : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">SN</th>
										<td>
											{{
												hardwaresetups[selectedDetail].id_transmitter != null ? hardwaresetups[selectedDetail].id_transmitter : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">MAC Address</th>
										<td>
											{{
												hardwaresetups[selectedDetail].mac_address != null ? hardwaresetups[selectedDetail].mac_address : "-"
											}}
										</td>
									</tr>
									<!-- <tr>
										<th scope="row">{{ dicts.no_sn[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].serial_number != null ? hardwaresetups[selectedDetail].serial_number.serial_number : "-"
											}}
										</td>
									</tr> -->
									<!-- <tr>
										<th scope="row">{{ dicts.no_jb[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].jb != null ? hardwaresetups[selectedDetail].jb.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.vessel[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].vessel != null ? hardwaresetups[selectedDetail].vessel.name : "-"
											}}
										</td>
									</tr> -->
									<!-- <tr>
										<th scope="row">{{ dicts.packet[dicts.lang] }}</th>
										<td>{{ translatePacket(hardwaresetups[selectedDetail].packet) }}</td>
									</tr> -->
									<!-- <tr>
										<th scope="row">Forward</th>
										<td>{{ translateForward(hardwaresetups[selectedDetail].forward) }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.test_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_test | timeformat }}</td>
									</tr> -->
									<tr>
										<th scope="row">{{ dicts.activate_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_active | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.due_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_due | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">NOC</th>
										<td>
											{{
												hardwaresetups[selectedDetail].noc != null ? hardwaresetups[selectedDetail].noc.noc : "-"
											}}
										</td>
									</tr>
									<!-- <tr>
										<th scope="row">{{ dicts.skat_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_skat | timeformat }}</td>
									</tr> -->
									<tr>
										<th scope="row">Status</th>
										<td>{{ 
												hardwaresetups[selectedDetail].notes != null ? hardwaresetups[selectedDetail].notes : "-"
											}}
										</td>
									</tr>

									</tbody>

								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-hardware'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories-hardware" size="lg"
				         title="Detail History" scrollable no-close-on-backdrop @hide="historydetailModalClose">
					<b-container fluid v-if="!loadData&&hardwaresetups.length>0">
						<b-row class="pt-1" v-if="hardwaresetups[selectedHistories]!=undefined">
							<b-col cols="12">
								<table rules="rows" class="table w-100">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="6" scope="row">Detail
											History
										</th>
									</tr>
									<tr>
										<th scope="row">{{ dicts.date[dicts.lang] }}</th>
										<th scope="row">{{ dicts.no_sn[dicts.lang] }}</th>
										<th scope="row">ID Transmitter</th>
										<th scope="row">{{ dicts.no_jb[dicts.lang] }}</th>
										<th scope="row">Status</th>
										<th scope="row">{{ dicts.notes[dicts.lang] }}</th>
									</tr>
									<tr v-for="history in hardwaresetups[selectedHistories].histories"
									    v-bind:key="'history'+history.id">
										<td>
											<b>{{ history.date_at != null ? history.date_at : "-" | timeformat }}</b>
										</td>
										<td> {{ history.old_serial_number != null ? history.old_serial_number.serial_number : "-" }}</td>
										<td>{{ history.old_id_transmitter != null ? history.old_id_transmitter : "-" }}</td>
										<td> {{ history.old_jb != null ? history.old_jb.serial_number : "-" }}</td>
										<td>{{ history.new_status }}</td>
										<td>{{ history.notes != null ? history.notes : "-" }}</td>
									</tr>
									<!-- <tr>
										<th scope="row">No JB</th>
										<td>{{hardwaresetups[selectedDetail].jb!=null?hardwaresetups[selectedDetail].jb.serial_number:'-'}}</td>
									</tr>
									<tr>
										<th scope="row">Nama Kapal</th>
										<td>{{hardwaresetups[selectedDetail].vessel!=null?hardwaresetups[selectedDetail].vessel.name:'-'}}</td>
									</tr>
									<tr>
										<th scope="row">Packet</th>
										<td>{{hardwaresetups[selectedDetail].packet}}</td>
									</tr>
									<tr>
										<th scope="row">APP</th>
										<td>{{hardwaresetups[selectedDetail].application.application_name}}</td>
									</tr>
									<tr>
										<th scope="row">Forward</th>
										<td>{{hardwaresetups[selectedDetail].forward}}</td>
									</tr>
									<tr>
										<th scope="row">Tanggal Tes</th>
										<td>{{hardwaresetups[selectedDetail].date_test | timeformat}}</td>
									</tr>
									<tr>
										<th scope="row">Aktif Tes</th>
										<td>{{hardwaresetups[selectedDetail].date_active | timeformat}}</td>
									</tr>
									<tr>
										<th scope="row">Jatuh Tempo</th>
										<td>{{hardwaresetups[selectedDetail].date_due | timeformat}}</td>
									</tr>
									<tr>
										<th scope="row">Tanggal SKAT</th>
										<td>{{hardwaresetups[selectedDetail].date_skat | timeformat}}</td>
									</tr> -->

									</tbody>

								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-histories-hardware'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

				<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-po" title="Konfirmasi hapus data" scrollable no-close-on-backdrop @hide="deleteModalClose">
					<b-container fluid v-if="!loadData">
						<b-row class="pt-1">
						<b-col cols="12" class="my-3">
							<h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
							<ul v-if="hardwaresetups.length>0">
								<li>Hardware Setup: {{hardwaresetups[selectedToDelete].name_airtime_price}}</li>
								<li>Price: {{hardwaresetups[selectedToDelete].price}}</li>
								<li>Price: {{airtimeprices[selectedToDelete].vendor!=null?airtimeprices[selectedToDelete].vendor.price:'-'}}</li>
							</ul>
						</b-col>
						<b-col cols="12" class="my-3 text-right"  v-if="deleteState">
							<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3"  v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data airtime price.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3"  v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data airtime price.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
						<hr>
						<button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button>
						<b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete-po'):''">Tutup</b-button>
						</div>
					</template>
				</b-modal> -->
				<modal-delete url="/api/inventaris/hardware-setup/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					{{ dicts.desc_delete[dicts.lang] }}:<br>
					<ul>
						<li>{{ dicts.no_sn[dicts.lang] }}: {{ itemToDelete.id_transmitter }}</li>
					</ul>
				</modal-delete>

			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import CreateVessel from "../../components/CreateVessel";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"create-vessel": CreateVessel,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			rowLimit: 10,
			listvessellabel: "",
			newsetupapplabel: "",
			newsetupnoclabel: "",
			newsetupodplabel: "",
			newsetupjblabel: "",
			newsetupsnlabel: "",
			updateOdplabel: "",
			nextUrl: null,
			prevUrl: null,
			perPage: null,
			isMobile: false,
			itemToDelete: {},
			deleteId: 0,
			selectedVesselName: "",
			selectedVesselId: 0,
			hardwaresetups: [],
			searchValue: "",
			loadData: true,
			savingNewHardwareSetup: false,
			updating: false,
			updatingStatus: false,
			updateSaved: false,
			updateSavedStatus: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedToDelete: 0,
			errorNewHardwareSetup: false,
			errorUpdate: false,
			errorUpdateStatus: false,
			errorHardwareSetupList: [],
			newHardwareSetupSaved: false,
			selectedIdforVessel: 0,
			selectedIdforEdit: 0,
			selectedIdforEditStatus: 0,
			selectedTab: 0,
			selectedTabStatus: 0,
			selectedDetail: 0,
			selectedHistories: 0,
			newHardwareSetup: {
				serial_number_id: "",
				jb_id: "",
				vesselExisting: "existing",
				vessel_id: "",
				id_transmitter: "",
				status: "new",
				packet: "test_idp690",
				// aplication:'VMS',
				application_id: "",
				noc:"",
				splitter_number:"",
				forward: "tidakada",
				date_test: "",
				date_active: "",
				date_skat: "",
				date_due: "",
				notes: "",
				jbNumber: ""
			},
			formHardwareSetupActive: false,
			hardwaresetupTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
								{
					label: {
						id: "Nama",
						en: "Name"
					},
					key: "application_name"
				},
				{
					label: {
						id: "CID",
						en: "CID"
					},
					key: "null"
				},
				{label: "ODP",	key: "item"},
				{label: "SN", key: null},
				{label: "Mac Adress", key: null},
				// {label: "ODP (Splitter Number)", key: "hardware_name"},
				{
					label: {
						id: "Start Date",
						en: "Start Date"
					},
					key: null
				},
				{
					label: {
						id: "Due Date",
						en: "Due Date"
					},
					key: null
				},
				{label: "NOC",	key: "noc"},
				{label: "Status",	key: "status"},
				{
					label: {
						id: "Tindakan",
						en: "Action"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				add_form: {
					id: "Tambah hardware setup baru",
					en: "Add hardware setup"
				},
				tittle_form: {
					id: "Form hardware setup",
					en: "New hardware setup form"
				},
				no_sn: {
					id: "Nomor SN",
					en: "SN number"
				},
				no_jb: {
					id: "Nomor JB",
					en: "JB number"
				},
				customer_name: {
					id: "Nama Pelanggan",
					en: "Customer Name"
				},
				vessel: {
					id: "Nama kapal",
					en: "Vessel name"
				},
				jb_number: {
					id: "Nomor JB",
					en: "JB Number"
				},
				packet: {
					id: "Paket",
					en: "Packet"
				},
				test_date: {
					id: "Tanggal Aktif",
					en: "Active Date"
				},
				activate_date: {
					id: "Start Date",
					en: "Start Date"
				},
				skat_date: {
					id: "Tanggal SKAT",
					en: "SKAT Date"
				},
				due_date: {
					id: "Due Date",
					en: "Due Date"
				},
				notes: {
					id: "Notes",
					en: "Notes"
				},
				submit: {
					id: "Simpan",
					en: "Submit"
				},
				new_vessel: {
					id: "Kapal baru",
					en: "New vessel"
				},
				list_vessel: {
					id: "Daftar kapal",
					en: "List vessel"
				},
				close: {
					id: "Tutup",
					en: "Close"
				},
				date: {
					id: "Tanggal",
					en: "Date"
				},
				desc_delete: {
					id: "Yakin mau menghapus data dengan detail berikut",
					en: "You are sure you want to delete data with the following details"
				}
			},
			packetTypeOptions: [
				{label: "Not Active", value: "not_active"},
				{label: "MSP Plan Test IDP690", value: "test_idp690"},
				{label: "Activation IDP690 10k 01", value: "activation_idp690_10k_01"},
				{label: "Activation IDP690 10k 02", value: "activation_idp690_10k_02"},
				{label: "Activation IDP690 10k 03", value: "activation_idp690_10k_03"},
				{label: "Activation ST6100 10k", value: "activation_st6100_10k"},
				{label: "Activation 1001", value: "activation_100k"},
				{label: "Blocked", value: "blocked"}
			],
			statusTypeOptions: [
				{label: "New", value: "new"},
				{label: "Repair", value: "repair"},
				{label: "Replacement", value: "replacement"}
			],
			// aplicationTypeOptions:[
			//     {label:'VMS',value:'vms'},
			//     {label:'eLogBook',value:'elogbook'},
			//     {label:'eBorang',value:'ebarang'},
			// ],
			forwardTypeOptions: [
				{label: "Tidak Ada", value: "tidak ada"},
				{label: "PSDKP", value: "psdkp"},
				{label: "SDI", value: "sdi"},
				{label: "Swasta", value: "swasta"}
			]
			// statusTypeOptions:[
			//     {label:'Aktif',value:'active'},
			//     {label:'Tidak aktif',value:'inactive'},
			// ],
		};
	},
	created() {
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getHardwareSetups();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing Hardware setup lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		translatePacket(role) {
			var label = "";
			switch (role) {
				case "not_active":
					label = "Not Active";
					break;
				case "test_idp690":
					label = "MSP Plan Test IDP690";
					break;
				case "activation_idp690_10k_01":
					label = "Activation IDP690 10k 01";
					break;
				case "activation_idp690_10k_02":
					label = "Activation IDP690 10k 02";
					break;
				case "activation_idp690_10k_03":
					label = "Activation IDP690 10k 03";
					break;
				case "activation_st6100_10k":
					label = "Activation ST6100 10k";
					break;
				case "activation_100k":
					label = "Activation 1001";
					break;
				case "blocked":
					label = "Blocked";
					break;
			}
			return label;
		},
		translateForward(role) {
			var label = "";
			switch (role) {
				case "tidak ada":
					label = "Tidak Ada";
					break;
				case "psdkp":
					label = "PSDKP";
					break;
				case "sdi":
					label = "SDI";
					break;
				case "swasta":
					label = "Swasta";
					break;
			}
			return label;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getHardwareSetups();
			}
		},
		clearHQCData() {
			this.newHardwareSetup.serial_number_id;
		},
		clearHQCDataStatus() {
			this.hardwaresetups[selectedIdforEditStatus].serial_number_id;
		},
		createVesselResult(data) {
			if (data.status) {
				console.log(this.selectedVesselId = data.data.id);
				this.selectedVesselName = data.data.name;
				this.selectedVesselId = data.data.id;
				this.newHardwareSetup.vessel_id = data.data.id;
				this.saveNewvessel = data.data.name;
				this.$bvModal.hide("modal-create-vessel");
			}
		},
		changePage(isNext) {
			let url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url).searchParams);
			const myParams = params.get("page");
			const newUrl = this.$baseUrl + "/api/inventaris/hardware-setup?limit=" + this.rowLimit + "&page=" + myParams;

			this.currentPage = myParams;
			this.getHardwareSetups(newUrl);
		},
		getHardwareSetups(url = (this.$baseUrl + "/api/inventaris/hardware-setup?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.perPage = parseInt(result.data.per_page);
				this.currentPage = result.data.current_page;
				this.hardwaresetups = result.data.data;
				// console.log(this.hardwaresetups)
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		updateHardwareSetup() {
			this.updating = true;
			this.errorUpdate = false;
			console.log(this.hardwaresetups[this.selectedIdforEdit]);
			axios.put(
				this.$baseUrl + "/api/inventaris/hardware-setup/" + this.hardwaresetups[this.selectedIdforEdit].id,
				this.hardwaresetups[this.selectedIdforEdit],
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					this.getHardwareSetups();
					setTimeout(() => {
						this.$bvModal.hide("modal-edit-hardware");
						this.updateSaved = false;
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},

		updateStatusHardwareSetup() {
			this.updatingStatus = true;
			this.errorUpdateStatus = false;
			console.log(this.hardwaresetups[this.selectedIdforEditStatus]);
			axios.put(
				this.$baseUrl + "/api/inventaris/hardware-setup/" + this.hardwaresetups[this.selectedIdforEditStatus].id,
				{
					status: this.hardwaresetups[this.selectedIdforEditStatus].status,
					date_at: this.hardwaresetups[this.selectedIdforEditStatus].date_at,
					notes: this.hardwaresetups[this.selectedIdforEditStatus].notes,
					serial_number_id: this.hardwaresetups[this.selectedIdforEditStatus].serial_number_id,
					jb_id: this.hardwaresetups[this.selectedIdforEditStatus].jb_id,
					id_transmitter: this.hardwaresetups[this.selectedIdforEditStatus].id_transmitter
				},
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updatingStatus = false;
					this.updateSavedStatus = true;
					this.getHardwareSetups();
					setTimeout(() => {
						this.updateSavedStatus = false;
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updatingStatus = false;
				this.errorUpdateStatus = true;
				console.log(err.response);
			});
		},
		smartSearchUpdatedVessel(data, index) {
			this.newHardwareSetup.vessel_id = data.id;
			this.selectedVesselId = data.id;
			this.selectedVesselName = data.name;
			// UNTUK MENGHAPUS MODAL
			this.$bvModal.hide("modal-create-vessel");
			//console.log(this.newHardwareSetup.vessel_id[index])
		},
		updateKapal(data) {
			this.hardwaresetups[this.selectedIdforEdit].vessel_id = data.id;
		},
		updateNewHsPacket(data) {
			this.newHardwareSetup.packet = data;
		},
		updateNewHsStatus(data) {
			this.newHardwareSetup.status = data;
		},
		updateNewHsAplication(data) {
			this.newHardwareSetup.aplication = data;
		},
		updateNewHsForward(data) {
			this.newHardwareSetup.forward = data;
		},
		smartSearchAddSerialNumber(data) {
			console.log("serial number selected");
			console.log(data);
			this.newHardwareSetup.serial_number_id = data.id;
		},
		smartSearchAddNoJb(data) {
			this.newHardwareSetup.jb_id = data.id;
		},
		smartSearchUpdateNoJb(data) {
			this.hardwaresetups[this.selectedIdforEditStatus].jb_id = data.id;
		},
		smartSearchEditSerialNumber(data) {
			console.log("serial number selected");
			console.log(data);
			this.hardwaresetups[this.selectedIdforEditStatus].serial_number_id = data.id;
		},
		smartSearchEditNoJb(data) {
			this.hardwaresetups[selectedIdforEditStatus].jb_id = data.id;
		},
		smartSearchAddApplication(data) {
			this.newHardwareSetup.application_id = data.id;
		},
		smartSearchAddNoc(data) {
			this.newHardwareSetup.noc_id = data.id;
		},
		smartSearchAddSplitterNumber(data) {
			this.newHardwareSetup.master_hardware_id = data.id;
		},
		smartSearchAddPacket(data) {
			this.newHardwareSetup.packet = data.id;
		},
		smartSearchUpdateApplication(data) {
			this.hardwaresetups[this.selectedIdforEditStatus].application_id = data.id;
		},
		smartSearchUpdateMasterHardware(data) {
			this.hardwaresetups[this.selectedIdforEditStatus].master_hardware_id = data.id;
		},
		AddNewVesselStatus(data) {
			this.newvessel.status = data;
		},
		// saveNewPurchaseOrder(){
		//     this.savingNewAirtimePrice=true
		//     this.errorNewAirtimePrice=false
		//     console.log(this.newPurchaseOrder)
		//     if(this.newPurchaseOrder.name_airtime_price!='' && this.newPurchaseOrder.price){
		//         axios.post(this.$baseUrl+'/api/master/airtimeprice',
		//         {
		//             name_airtime_price:this.newPurchaseOrder.name_airtime_price,
		//             price:this.newPurchaseOrder.price
		//         },
		//         {
		//             'headers':
		//             {
		//                 'Authorization':'Bearer '+localStorage.getItem('accessToken')
		//             }
		//         }).then((result)=>{
		//             //console.log(result)
		//             if(result.data.create){
		//                 this.getAirtimePrices();
		//             }
		//             this.newAirtimePrice.name_airtime_price='',
		//             this.newAirtimePrice.price='',
		//             this.savingNewAirtimePrice=false
		//             this.newAirtimePriceSaved=true

		//             setTimeout(() => {
		//                 this.newAirtimePriceSaved=false
		//                 this.formAirtimePriceActive=false
		//             }, 1500);

		//         }).catch((err)=>{
		//check if token fail
		//   if(err.response && err.response.status==401){
		//     localStorage.removeItem('accessToken')
		//   this.$router.push('/login')
		//   }
		//             console.log(err.response)
		//             this.errorAirtimePriceList=[]
		//             this.errorAirtimePriceList=Object.values(err.response.data.errors)
		//             console.log(this.errorAirtimePriceList)
		//             this.errorNewAirtimePrice=true
		//             this.savingNewAirtimePrice=false
		//         })
		//     }
		// },
		deleteItem(index) {
			console.log("button delete untuk user id: " + index);
		},
		// updateUserRoleValue(newValue){
		//     this.newPurchaseOrder.role=newValue
		// },
		// setNewClientId(newId){
		//     this.newPurchaseOrder.clientId = newId;
		//     console.log(this.newPurchaseOrder.clientId)
		// },
		// updateNewHardwareItemType(value){
		//     this.newPurchaseOrder.itemType=value;
		// },
		// smartSearchUpdated(data,index){
		//     this.newPurchaseOrder.hardware.id[index]=data.id
		//     console.log(this.newPurchaseOrder.hardware.id[index])
		// },
		// smartSearchUpdatedVendor(data,index){
		//     this.newPurchaseOrder.vendor_id[index]=data.id
		//     console.log(this.newPurchaseOrder.vendor_id[index])
		// },

		saveNewHardwareSetup() {
			//if(this.newPurchaseOrder.no_po!=''){}
			// console.log(this.newPurchaseOrderSaved)
			// return;
			this.savingNewHardwareSetup = true;
			this.errorNewHardwareSetup = false;
			// console.clear();
			// console.log(this.newHardwareSetup)
			// return;

			axios.post(this.$baseUrl + "/api/inventaris/hardware-setup", this.newHardwareSetup,
				// {
				//     'serial_number_id':this.newHardwareSetup.serial_number_id,
				//     'jb_id':this.newHardwareSetup.jb_id,
				//     'vessel_id':this.newHardwareSetup.vessel_id,
				//     'id_transmitter':this.newHardwareSetup.id_transmitter,
				//     'status':this.newHardwareSetup.status,
				//     'packet':this.newHardwareSetup.packet,
				//     'aplication':this.newHardwareSetup.aplication,
				//     'application_id':this.newHardwareSetup.application_id,
				//     'forward':this.newHardwareSetup.forward,
				//     'date_test':this.newHardwareSetup.date_test,
				//     'date_active':this.newHardwareSetup.date_active,
				//     'date_skat':this.newHardwareSetup.date_skat,
				//     'date_due':this.newHardwareSetup.date_due,
				// },
				{
					"headers":
						{"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				console.log(result);
				this.savingNewHardwareSetup = false;
				this.newHardwareSetupSaved = true;
				this.resetForm();
				this.getHardwareSetups();
				setTimeout(() => {
					this.formHardwareSetupActive = false;
					this.newHardwareSetupSaved = false;
				}, 1000);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.clear();
				console.log(err.response);
				this.errorHardwareSetupList = [];
				this.errorHardwareSetupList = Object.values(err.response.data.errors);
				console.log(this.errorHardwareSetupList);
				this.savingNewHardwareSetup = false;
				this.errorNewHardwareSetup = true;
			});
			// }else{
			//   console.log('data invalid')
			//   this.errorNewHardwareSetup=true
			//   this.savingNewHardwareSetup=false
			//   this.errorHardwareSetupList=[]
			//   if(this.newHardwareSetup.vessel_id==''){
			//       this.errorHardwareSetupList.push(["- Mohon isi kapal"])
			//   }
			// }
		},
		resetForm() {
			this.newHardwareSetup.serial_number_id = "";
			this.newHardwareSetup.jb_id = "";
			this.newHardwareSetup.vesselExisting = "existing";
			this.newHardwareSetup.vessel_id = "";
			this.newHardwareSetup.id_transmitter = "";
			this.newHardwareSetup.status = "new";
			this.newHardwareSetup.packet = "test_idp690";
			// aplication='VMS';
			this.newHardwareSetup.application_id = "";
			this.newHardwareSetup.noc = "";
			this.newHardwareSetup.splitter_number = "";
			this.newHardwareSetup.forward = "tidakada";
			this.newHardwareSetup.date_test = "";
			this.newHardwareSetup.date_active = "";
			this.newHardwareSetup.date_skat = "";
			this.newHardwareSetup.date_due = "";
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(
				this.$baseUrl + "/api/inventaris/hardware-setup/" + this.hardwaresetups[this.selectedToDelete].id,
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			)
				.then((result) => {
					if (result.status == 200) {
						this.hardwaresetups.splice(this.selectedToDelete, 1);
						this.deleted = true;
						setTimeout(() => {
							this.deleted = false;
						}, 1500);

					} else {
						this.deleteFail = true;
					}
					this.deleteState = false;
				}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-po");
			}
		},
		detailModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-hardware");
			}
		},
		historydetailModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-histories-hardware");
			}
		}


	}
};
</script>
<style scoped>
.dropdown-menu {
	display: none;
}

.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal-content {
    margin: -5.00rem auto;
} */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 15%;
}

::v-deep .modal.show .modal-dialog {
	transform: translate(0px, 10%);
}

::v-deep .modal-dialog-scrollable .modal-content {
	max-height: calc(100vh - 3.5rem);
}

::v-deep .modal.show .modal-dialog {
	transform: none;
	-webkit-transform: none;
}
</style>
